/** @jsx jsx */
import { jsx, css } from '@emotion/core';
import { Breakpoints, GridConfig } from '../../../styles/Grid/GridSizes';

export const resetButton = css({
  background: 'transparent',
  border: 'none',
});

const swiperBreakpoints = {
  sm: Breakpoints.md - 1,
  md: Breakpoints.lg - 1,
};

export const swiperParams = {
  breakpoints: {
    [swiperBreakpoints.sm]: {
      slidesPerView: 1,
      spaceBetween: GridConfig.sm.gutter,
      noSwiping: false,
    },
    [swiperBreakpoints.md]: {
      slidesPerView: 2,
      spaceBetween: GridConfig.md.gutter,
      noSwiping: false,
    },
  },
  noSwiping: true,
  slidesPerView: 3,
  spaceBetween: GridConfig.lg.gutter,
  watchOverflow: true,
  shouldSwiperUpdate: true,
  pagination: {
    el: '.popular-in-this-area-swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  renderPrevButton: () => (
    <button
      css={resetButton}
      className="icon-arrow-previous swiper-button-prev"
    ></button>
  ),
  renderNextButton: () => (
    <button
      css={resetButton}
      className="icon-arrow-next swiper-button-next"
    ></button>
  ),
};
